import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pin-2"} maskId="square-filled-radius-0-stroke-1-IconPin2"><path d="M16 8.57129C18.39 9.95381 20 12.5381 20 15.5V16H12.5V20.5L12 22L11.5 20.5V16H4V15.5C4 12.5381 5.61003 9.95381 8 8.57129V2H16V8.57129Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPin2;
